import { PortalRequest as request } from "@/utils/request";
// 成果列表
export const getAchvList = (params, data) => {
  return request({
    url: "/achv/list-public-achv",
    method: "post",
    params,
    data: {
      ...data,
    },
  });
};
// 成果详情
export const getAchvInfo = (id) => {
  return request({
    url: `/achv/${id}/info`,
    method: "get",
  });
};
// 新增浏览数
export const addAchvViewed = (id) => {
  return request({
    url: `/achv/${id}/add-viewed`,
    method: "post",
  });
};
// 新增分享数
export const addAchvShared = (id) => {
  return request({
    url: `/achv/${id}/add-shared`,
    method: "post",
  });
};
// 相似成果列表
export const getAchvSimilar = (params, id) => {
  return request({
    url: `/achv/${id}/list-similar-achv`,
    method: "get",
    params,
  });
};
// 我的成果列表
export const getUserAchvList = (params, data) => {
  return request({
    url: "/achv/list-own-achv",
    method: "post",
    params,
    data,
  });
};
// 新建一个草稿
export const achvCreateDraft = (data) => {
  return request({
    url: "/achv/create-draft",
    method: "post",
    data,
  });
};
// 更新已有草稿
export const achvUpdateDraft = (data) => {
  return request({
    url: "/achv/update-draft",
    method: "post",
    data,
  });
};
// 删除已有草稿
export const achvDelete = (id) => {
  return request({
    url: `/achv/${id}/delete`,
    method: "delete",
  });
};
// 成果评论列表
export const achvCommentList = (params, id) => {
  return request({
    url: `/achv/${id}/list-comment`,
    method: "get",
    params,
  });
};
// 发布成果评论
export const achvComment = (data, id) => {
  return request({
    url: `/achv/${id}/create-comment`,
    method: "post",
    data,
  });
};
// 提交已有草稿申报
export const submitAchvDraft = (data) => {
  return request({
    url: `/achv/submit-from-draft`,
    method: "post",
    data,
  });
};
// 直接提交申报(无草稿)
export const submitAchvZero = (data) => {
  return request({
    url: `/achv/submit-from-zero`,
    method: "post",
    data,
  });
};
